import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { IconClose, Text } from '@zillow/constellation';

import notificationMixin from '../../themes/components/Notification';
import notificationCloseMixin from '../../themes/mixins/notificationCloseMixin';

import { logDeprecateMessage } from '../../util/logging/logging';

export const StyledNotification = styled.div`
  ${notificationMixin}
`;

export const StyledCloseNotification = styled.div`
  ${notificationCloseMixin}
`;

/**
 *
 * @deprecated
 */
const Notification = (props) => {
  logDeprecateMessage(
    `The 'Notification' component from zrs-comet will be removed in the next MAJOR release, use 'Banner' from constellation instead 
        http://constellation.pages.zgtools.net/constellation-site/constellation-api.html#banner`,
  );
  const { children, fontColor, iconClose, iconCloseSize, onClose } = props;

  const handleOnClose = () => {
    if (onClose) {
      onClose();
    }
  };

  return (
    <StyledNotification {...props}>
      <Text fontColor={fontColor}>{children}</Text>
      <StyledCloseNotification onClick={handleOnClose}>
        {iconClose && <IconClose size={iconCloseSize} />}
      </StyledCloseNotification>
    </StyledNotification>
  );
};

Notification.propTypes = {
  /** Notification content */
  children: PropTypes.node,
  /** Notification font color */
  fontColor: PropTypes.string,
  /** False will not render IconClose */
  iconClose: PropTypes.bool,
  /** Notification close icon size */
  iconCloseSize: PropTypes.string,
  /** Notification type */
  type: PropTypes.oneOf(['default', 'success', 'info', 'error']),
  /** Function called with the notification is clicked */
  onClose: PropTypes.func,
};

Notification.defaultProps = {
  fontColor: 'textWhite',
  iconClose: true,
  iconCloseSize: 'xs',
  type: 'default',
  onClose: () => {},
};

export default Notification;
